import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { NavLink } from "react-router-dom";
import {ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent} from "../components/";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

interface INewsListState {
  ParamAPIPagine: Dati.CParamAPIPagine;
  Caricamento: boolean;
  Aggiornare: number;
  Dati?: Dati.CRisAPIPagineNews;
  ParametriUtente: Dati.TListaParametri;
  Parametri: Dati.TListaParametri;
}

export class NewsList extends BaseComponent<
  Glob.IRouteGlobaleProps,
  INewsListState
> {
  private ParametriFissi: Dati.TListaParametri = {};
  public constructor(props: any) {
    super(props);
    let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
    Param.Sessione = Glob.GetSessione().Sessione;
    Param.Numero = 10;
    Param.Pagina = 1;
    this.state = {
      Aggiornare: 1,
      Caricamento: true,
      ParamAPIPagine: Param,
      Dati: undefined,
      ParametriUtente: {},
      Parametri: this.ParametriFissi
    };
    this.OnChange = this.OnChange.bind(this);
  }

  private OnCambioPagina = (sender: Paginatore, pagina: number) => {
    this.state.ParamAPIPagine.Pagina = pagina;
    this.setState({
      ParamAPIPagine: this.state.ParamAPIPagine,
      Aggiornare: this.state.Aggiornare + 1,
      Caricamento: true
    });
  };

  private OnOrdinamento = (Campo: string, Verso: string) => {
    this.state.Parametri["OrdinaCampo"] = Campo;
    this.state.Parametri["OrdinaVerso"] = Verso;
    this.setState({
      Parametri: this.state.Parametri,
      Aggiornare: this.state.Aggiornare + 1,
      Caricamento: true
    });
  }

  private OnInvio = (sender: ChiamaAPI) => {
    return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi); //to create a single list of all parameters
  };

  Tabella: any = null;
  TabellaOrdinamento: [number, string] = [1, "asc"];
  TabellaAggiorna: number = 0;

  private OnRis = (
    sender: ChiamaAPI,
    dati: Dati.CRisAPIPagineNews,
    datiNuovi: boolean
  ): React.ReactNode => {
    if (datiNuovi) {
      this.TabellaAggiorna = 0;
      if (this.Tabella != null) {
        this.Tabella.destroy();
      }
      this.setState({ Dati: dati, Caricamento: false }, () =>
        this.AttivaTabella()
      );
    }

    if (dati.Errore) {
      return false;
    }

    if (dati.Dati.length == 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={7} className="TextLeft alert-warning">
              <div className="kt-alert__icon">
                <i className="fa fa-exclamation-triangle"> </i>
                <span>
                  {Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      );
    } else {
      return (
        <tbody>
          {dati.Dati.map(dato => (
            <tr key={dato.ID_News}>
              <td data-field="ID_News" className="TextCenter">
                <a
                  href="#"
                  className="arrow"
                  onClick={e => {
                    e.preventDefault();
                    this.props.history.push("/news/" + dato.ID_News);
                  }}
                >
                  {dato.ID_News}
                </a>
              </td>
              <td data-field="Title" className="TextLeft">{dato.Title}</td>
              <td data-field="Category" className="TextLeft">{dato.Category}</td>
              <td data-field="edit" className="TextCenter">
                <a
                  href="#"
                  className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only"
                  onClick={e => {
                    e.preventDefault();
                    this.props.history.push("/news/" + dato.ID_News);
                  }}
                >
                  <i className="la la-edit"></i>
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      );
    }
  };

  private AttivaTabella() {
    if (this.TabellaAggiorna != this.state.Aggiornare) {
      this.TabellaAggiorna = this.state.Aggiornare;
      if (this.state.Dati != undefined) {
        let T: any = $(this.refs.tabella);

        this.Tabella = T.DataTable({
          responsive: true,
          paging: false,
          searching: false,
          info: false,
          ordering: true,
          destroy: true,
          order: this.TabellaOrdinamento,
          columnDefs: [
            {
              targets: [3],
              orderable: false
            }
          ]
        });
    
        T.one("order.dt", (e: any, settings: any) => {
          let TO: any = this.Tabella.order();
          if (TO != undefined && TO[0] != undefined) {
            this.TabellaOrdinamento[1] = TO[0][1];
            this.TabellaOrdinamento[0] = TO[0][0];
            switch (this.TabellaOrdinamento[0]) {
              case 0:
                this.OnOrdinamento("ID_News", this.TabellaOrdinamento[1].toUpperCase());
                break;
              case 1:
                this.OnOrdinamento("Title", this.TabellaOrdinamento[1].toUpperCase());
                break;
              case 2:
                this.OnOrdinamento("Category", this.TabellaOrdinamento[1].toUpperCase());
                break;
            }
          }
        });
      }
    }
  }

  public componentDidMount() {
    this.AttivaTabella();
  }

  public componentDidUpdate() {
      this.AttivaTabella();
  }

  private OnErrorNews = (sender: ChiamaAPI, errore: Error) => {
    this.setState({ Caricamento: false });
    return (
      <tbody>
        <tr>
          <td colSpan={7}>{Trad.Trad("ListaErrore")}</td>
        </tr>
      </tbody>
    );
  }

  render() {
    let Accessibility: string = "hidden";
    if (Glob.AzioneAbilitata("NewsController", Glob.Scrittura))
      Accessibility = "";
    if (!Glob.AzioneAbilitata("NewsController", Glob.Lettura)) {
      this.props.history.push("/ErroreAccesso");
      return false;
    }
    return (
      <div className="kt-portlet">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <div className="kt-portlet__head-label">
              <span className="kt-portlet__head-icon">
                <i className="fa fa-newspaper"></i>
              </span>
              <h3 className="kt-portlet__head-label">{Trad.Trad("Notizia")}</h3>
            </div>
          </div>
          <div className="portlet__head-tools">
            <ul className="kt-portlet__nav">
              <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + Accessibility} aria-expanded="true" >
                <NavLink to="/news/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                  <i className="fa fa-plus"></i>
                </NavLink>
              </div>
            </ul>
          </div>
        </div>
        <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
          <div className="kt-portlet__body">
            <div className="form-group kt-form login-form__group row dashed-border-bottom">

              <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
              <div className="col-lg-3 form-control-plaintext">
                <input
                  onChange={this.OnChange}
                  type="text"
                  value={this.state.ParametriUtente["ID_News"] || ""}
                  name="ParametriUtente[ID_News]"
                  className="form-control kt-input"
                  placeholder={Trad.Trad("ID")}
                />
              </div>
              
              <label className="col-lg-1 col-form-label">
                {Trad.Trad("Titolo")}
              </label>
              <div className="col-lg-3 form-control-plaintext">
                <input
                  onChange={this.OnChange}
                  type="text"
                  value={this.state.ParametriUtente["Title"] || ""}
                  name="ParametriUtente[Title]"
                  className="form-control kt-input"
                  placeholder={Trad.Trad("Titolo")}
                />
              </div>

              <label className="col-lg-1 col-form-label">
                {Trad.Trad("Categoria")}
              </label>
              <div className="col-lg-2 form-control-plaintext">
                <input
                  onChange={this.OnChange}
                  type="text"
                  value={this.state.ParametriUtente["Category"] || ""}
                  name="ParametriUtente[Category]"
                  className="form-control kt-input"
                  placeholder={Trad.Trad("Categoria")}
                />
              </div>

            </div>
          </div>
          <div className="kt-portlet__foot kt-portlet__foot--fit">
            <div className="kt-form login-form__actions kt-form login-form__actions--middle">
              <div className="row">
                <div className="col kt-form__actions kt-form__actions--center">
                  <Bottone
                    Default
                    Attesa={this.state.Caricamento}
                    OnClick={e => {
                      this.state.ParamAPIPagine.Pagina = 1;
                      this.setState({
                        Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true),
                        ParamAPIPagine: this.state.ParamAPIPagine,
                        Caricamento: true,
                        Aggiornare: this.state.Aggiornare + 1
                      });
                    }}
                    Testo={Trad.Trad("Cerca")}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <Paginatore
          Pagina={this.state.ParamAPIPagine.Pagina}
          Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine}
          OnCambioPagina={this.OnCambioPagina}
        />
        <div>
          <table
            className="table table-hover dtr-inline dataTable"
            id="tabella"
            ref="tabella"
          >
            <thead>
              <tr className="sfondoTab">
                <th data-field="ID_News" className="TextCenter">ID</th>
                <th data-field="Title" className="TextLeft">{Trad.Trad("Titolo")}</th>
                <th data-field="Category" className="TextLeft">{Trad.Trad("Categoria")}</th>
                <th className="TextCenter">{Trad.Trad("Modifica")}</th>
              </tr>
            </thead>
            <ChiamaAPI
              Aggiornare={this.state.Aggiornare}
              URL="/api/News/Search"
              ParamURLClasse={this.state.ParamAPIPagine}
              OnInvio={this.OnInvio}
              OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
              OnErrore={this.OnErrorNews}
            />
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/form/NewsList.tsx